import React from "react"
import PropTypes from "prop-types"
import { Card, CardBody } from "reactstrap"
import { withTranslation } from "react-i18next"

const ErrorMessage = ({ error, title, t, className = "", style = {} }) => {
  if (!error) return null

  return (
    <Card 
      className={className}
      style={{ 
        backgroundColor: 'transparent', 
        border: '1px solid #013f7c', 
        borderRadius: '6px',
        marginBottom: '20px',
        maxWidth: '50%',
        ...style 
      }}
    >
      <div style={{
        backgroundColor: '#013f7c',
        color: '#ffffff',
        padding: '10px 15px',
        borderTopLeftRadius: '6px',
        borderTopRightRadius: '6px',
        fontSize: '16px',
        fontWeight: '600',
        borderBottom: '1px solid #013f7c'
      }}>
        Error Message
      </div>

      <CardBody style={{ padding: '15px' }}>
        <div className="alert alert-danger mb-0" role="alert" style={{
          backgroundColor: '#ffffff',
          border: 'none',
          borderRadius: '4px',
          padding: '12px 16px'
        }}>
          <h6 className="alert-heading mb-2" style={{ 
            fontSize: '14px', 
            color: '#013f7c',
            marginBottom: '8px'
          }}>
            <span style={{ color: '#ce0000' }}>
              {title || t("operationFailed")}
            </span>
          </h6>
          
          <hr style={{ 
            borderColor: '#74788d', 
            margin: '8px 0 12px 0',
            opacity: 0.3
          }} />
          
          <div style={{ 
            fontSize: '13px', 
            lineHeight: '1.4',
            wordBreak: 'break-word',
            color: '#013f7c'
          }}>
            {error}
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

ErrorMessage.propTypes = {
  error: PropTypes.string,
  title: PropTypes.string,
  t: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default withTranslation()(ErrorMessage)
